export const API_KEY="AIzaSyAhyMx0nJOzhkGfzA1WgY8N3ZpZ4IuRxEg";

export default API_KEY;